module.exports = __webpack_public_path__ + "img/tpay-orange-en.f6725daa.png";